var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0L13 0L16 3.6V4V6V14C16 15.1 15.1 16 14 16L2 16C0.9 16 0 15.1 0 14L0 6L0 4L0 3.6L3 0ZM2 14L14 14L14 6L2 6L2 14ZM3.94 2L2.27 4L13.74 4L12.07 2L3.94 2ZM10 10L6 10C5.45 10 5 9.55 5 9C5 8.45 5.45 8 6 8H10C10.55 8 11 8.45 11 9C11 9.55 10.55 10 10 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.d5aface4b0f587b3cc5e1c2fe87aad52.svg";
export { ForwardRef as ReactComponent };